import React, { useEffect, useState } from "react";

import { ApiCall, Colors, Web_url } from "../../common/Const";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import arrow from "../../assets/arrow.png";
import Profileleft from "./Profileleft";
import '../Myprofiecomponent/myorder.css'
// import chain from "../../assets/earring.png";
// import chain1 from "../../assets/jewel-1.png";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { Pagination, Rating, StepContent, StepLabel } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import EncryptDecrypt from "../../common/Crypto";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { images } from "../../common/Images";
import { MutatingDots } from "react-loader-spinner";

const Myorder = () => {

  const [orderDetails, setOrderDetails] = useState([]);
  const [settings, setSettings] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [currentpage, setCurrentpage] = useState(0);
  const [comment_error, setcommentError] = useState(false);
  const [ratings_error, setratingsError] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  // const DecryptData = async () => {
  //   let type = "decrypt";
  //   let format = "text";
  //   let id = localStorage.getItem("customerId");
  //   await EncryptDecrypt(id, type, format, (response) => {
  //     console.log("decode -->", response);
  //     setcusId(response);
  //   });
  // };
  // useEffect(()=>{
  //   DecryptData();
  // },[])
  const date = moment.now();
  const handleChangePage = (page) => {
    setCurrentpage(page);
    getOrders((page - 1) * 4);
  }
  useEffect(() => {
    ApiCall('appsetting').then((data) => {
      if (data.message == "Success") {
        setSettings(data.result);
      }
    })
  }, [])
  const ShowCheck = (data) => {
    navigate("/returnOrder", { state: { order_detail: data, settings: settings } });
    window.scrollTo({ top: 0, behavior: "smooth" })
  };
  const [loader, setloader] = useState(true)
  const [apiTxt, setapiTxt] = useState('')
  useEffect(() => {
    setloader(true);
    getOrders()
  }, [cusId])

  const getOrders = (page = 0) => {
    setloader(true);
    if (cusId != 0) {
      ApiCall('orderHistory', {
        customer_id: cusId,
        page: page
      }).then((data) => {
        console.log(data, "data")
        setapiTxt(data.message)
        if (data.message === "success") {
          setOrderDetails(data.result)
          setTotalCount(data.total_count)
          console.log(data.result);
        }
      }).catch((err) => {
        console.log(err, "err")
      });
    }
    setloader(false)
  }
  console.log(loader);
  const steps = [
    {
      label: 'Order Placed',
      description: ``,
    },
    {
      label: 'Order Confirmed',
      description:
        '',
    },
    // {
    //   label: 'Ready to ship',
    //   description: ``,
    // },
    {
      label: 'Delivered',
      description: ``,
    },
  ];
  const return_steps = [
    {
      label: 'Return Requested',
      description: ``,
    },
    {
      label: 'Return Accepted',
      description:
        '',
    },
    {
      label: 'Return Picked Up',
      description: ``,
    },
    {
      label: 'Completed',
      description: ``,
    },
  ];
  const calculateValue = (val) => {
    console.log("val", val)
    let total = 0;
    val.map((res) => {
      total += parseFloat(res.order_price * res.quantity);
    })
    return total;
  }
  const reviewSubmit = (e) => {
    e.preventDefault();
    if (e.target.order_status.value == "completed") {
      if (e.target.ratings.value === '') {
        setratingsError(true);
      }
      else {
        setratingsError(false);
      }
      if (e.target.comment.value === '') {
        setcommentError(true);
      }
      else {
        setcommentError(false);
      }
      if (e.target.comment.value !== '' && e.target.ratings.value !== '') {

        ApiCall('productReview', {
          customer_id: cusId,
          product_id: e.target.product_id.value,
          order_id: e.target.order_id.value,
          ratings: e.target.ratings.value,
          feedbacks: e.target.comment.value,
        }).then((data) => {
          console.log(data)
          if (data.message === "Success.") {
            toast.success('Review added successfully', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            getOrders((currentpage - 1) * 4);
          }
          else {
            toast.error('Review update Failed, try again!', {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }).catch((err) => {
          toast.error('Review update Failed, try again!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
      }
    }
    else {
      toast.error('Review will be added after product delivered!', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

  }
  return (
    <>
      {" "}
      {/* <Header /> */}
      <Header make={true} />
      <div className="profile-myorder">
        <div
          className="myprofilebox"
          style={{ backgroundColor: "#fef4f7", height: "100%" }}
        >
          <div style={{ width: "250px" }}>
            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-5">
                <a href="javascript:history.go(-1)"><button className="btn btn-basic p-0" style={{ background: Colors.Base_color, color: "white" }} ><img src={images.left} width={30} /><span style={{ position: "relative", left: "-8px", top: "2px" }}>Back</span></button></a>
              </div>
              <div className="col-7" style={{ paddingTop: "7px" }}>
                <h4>User Profile</h4>
              </div>
            </div>
          </div>
          <div
            className="profilecontainer row mx-0 gap-4"
            style={{ paddingTop: "20px", height: "100%", paddingBottom: '20px' }}
          >
            <Profileleft />
            {/* {orderDetails.length > 0 ?  */}
            <div
              className="right col-11 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
              style={{
                backgroundColor: Colors.white_color,
                height: "max-content",
                borderRadius: "20px",
                marginBottom: "40px",
                paddingLeft: "0px"
              }}
            > {orderDetails && orderDetails.length > 0 ?
              <div className="right-side w-100">
                <ul className="lists">
                  {
                    orderDetails.length > 0 ?
                      orderDetails.map((order) => {
                        return (
                          <li key={order.o_id}>
                            <Accordion style={{ backgroundColor: '#fff8fa', padding: '8px', borderRadius: "15px" }}>
                              <AccordionSummary
                                expandIcon={<img src={arrow} className="rotatearrow" alt="open"></img>}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <div className="myorders ">
                                  <img src={images.about_second} className="order-image rounded image-fluid" alt="open"></img>
                                </div>
                                <div className="pro-dtls">
                                  <h4 style={{ color: "#126a38" }}>{order.o_id}</h4>
                                  <span className={order.order_status === "completed" ? "order-status" : ""}>{(order.order_status === "pending") ? 'Status: Order placed' : (order.order_status === "processing") ? 'Status: Order Confirmed' :  (order.order_status === "completed") ? 'Delivered on ' + moment(order.updated_at).format('DD-MMM-yyyy') : (order.order_status === "completed") ? 'Status: Cancelled' : ''}</span> <br></br>

                                  {order.order_status === "completed" || order.order_status === "completed" ? null :
                                    <div className="mt-1"><small style={{ color: 'green' }}>Estimated Delivery on {moment(date).add(settings.estimate_delivery_days, "days").format('DD MMM')}</small><br></br></div>
                                  }
                                  <div className="mt-1"><span>{settings != '' ? settings.currency.symbol : ''} {order.total_amount}</span></div>
                                </div>
                              </AccordionSummary>
                              <hr></hr>
                              {
                                order.order_items.length > 0 ?
                                  order.order_items.map((order_item) => {
                                    console.log(order_item)
                                    return (
                                      <Accordion key={order_item.id}>
                                        <AccordionSummary expandIcon={<img src={arrow} className="rotatearrow" alt="open"></img>}
                                          aria-controls="panel1a-content"
                                          id="panel1a-header">
                                          <div className="myorders">
                                            <img src={Web_url.Domain_url + order_item.product_image} alt="product" className="order-image rounded image-fluid" width="145"
                                            ></img>
                                          </div>
                                          <div className="pro-dtls">
                                            <h4 style={{ color: "#126a38" }}>{order_item.product_name}</h4>
                                            <Rating style={{ fontSize: "30px" }} id="rating" name="no-value" value={order_item.product_rating} readOnly />
                                            {
                                              order_item.return_details !== null ? <div className="return-level">Return status : <span>{order_item.return_details.status === 0 ? "Requested" : order_item.return_details.status === 1 ? "Accepted" : "Rejected"}</span></div> : null
                                            }
                                          </div>


                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <p className="m-3">{settings != '' ? settings.currency.symbol : ''} {order_item.order_price} x {order_item.quantity}</p>
                                          <div className="orders-rates m-3">
                                            <div className="orders-container">
                                              <div className="left-desc d-flex flex-column gap-2">
                                                <small>Variant Name</small>
                                                <small>Weight</small>
                                                <small>Karat</small>
                                                <small>Order Size</small>
                                                <small>HUID</small>
                                              </div>
                                              <div className="left-desc d-flex flex-column gap-2">
                                                <small>:</small>
                                                <small>:</small>
                                                <small>:</small>
                                                <small>:</small>
                                                <small>:</small>
                                              </div>
                                              <div className="amounts d-flex flex-column gap-2">
                                                <small>{order_item.product_name}</small>
                                                <small>{order_item.weight}g</small>
                                                <small>{order_item.karat}k</small>
                                                <small>{order_item.order_sizes} mm</small>
                                                <small>{order_item.product_huid}</small>
                                              </div>
                                            </div>
                                          </div>
                                          {
                                            order_item.return_details !== null ?
                                              <div>
                                                <p className="mt-4 m-3" style={{ color: "#126a38" }}>Return Request Details</p>
                                                <div className="orders-rates m-3">
                                                  <div className="orders-container">
                                                    <div className="left-desc d-flex flex-column gap-2">
                                                      <small>Order Item Id</small>
                                                      <small>status</small>
                                                      <small>Reason for return</small>
                                                      {/* {
                                                        order.return_details.status === 4 && order_item.return_details.status === 1 ?
                                                          <>
                                                            <small>Refund Type</small>
                                                            <small>Refund Amount</small>
                                                          </>
                                                          : null
                                                      } */}
                                                    </div>
                                                    <div className="left-desc d-flex flex-column gap-2">
                                                      <small>:</small>
                                                      <small>:</small>
                                                      <small>:</small>
                                                      {/* {
                                                        order.return_details.status === 4 && order_item.return_details.status === 1 ?
                                                          <>
                                                            <small>:</small>
                                                            <small>:</small>
                                                          </>
                                                          : null
                                                      } */}
                                                    </div>
                                                    <div className="amounts d-flex flex-column gap-2">
                                                      <small>{order_item.return_details.order_item_id}</small>
                                                      <small>{order_item.return_details.status === 0 ? 'Requested' : order_item.return_details.status === 1 ? 'Accepted' : 'Rejected'}</small>
                                                      <small className="refund-re">{order_item.return_details.return_reason}</small>
                                                      {/* {
                                                        order.return_details.status === 4 && order_item.return_details.status === 1 ?
                                                          <>
                                                            <small>{order.return_details.refund_type === 1 ? "Wallet" : "Other"}</small>
                                                            <small>{order_item.return_details.refund_amount}</small>
                                                          </>
                                                          : null
                                                      } */}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              : null
                                          }

                                          <form onSubmit={reviewSubmit}>
                                            <h4 className="m-3" style={{ color: "#126a38" }}>Add Review</h4>
                                            <div class="form-group row m-2">
                                              <label class="col-sm-3 col-form-label">Add your rating</label>
                                              <div class="col-sm-9 mt-2">
                                                {
                                                  order_item.reviews !== '' ?
                                                    <Rating className="ratings" name="ratings" value={order_item.reviews.ratings} readOnly /> : <div><Rating className="ratings" name="ratings" />
                                                      <div className="err" style={{ display: ratings_error ? 'block' : 'none' }}>Choose ratings</div></div>
                                                }
                                              </div>
                                            </div>
                                            <div class="form-group row m-2">
                                              <label class="col-sm-3 col-form-label">Add your Comments</label>
                                              <div class="col-sm-9 mt-2">
                                                {
                                                  order_item.reviews !== '' ?
                                                    <textarea className="review-first" name="comment" rows="4" autoComplete="off" value={order_item.reviews.feedbacks} readOnly></textarea> : <div><textarea className="review-first" name="comment" rows="4" autoComplete="off" ></textarea><div className="err" style={{ display: comment_error ? 'block' : 'none' }}>Enter comments to add review</div></div>
                                                }
                                              </div>
                                              <input type="hidden" name="product_id" value={order_item.product_id} />
                                              <input type="hidden" name="order_id" value={order_item.order_id} />
                                              <input type="hidden" name="order_status" value={order.order_status} />
                                              <div className="col-sm-10 m-4 d-flex justify-content-md-end justify-content-xs-center">
                                                {
                                                  order_item.reviews !== '' ?
                                                    null : <button
                                                      type="submit"
                                                      className="btn add-bag rounded"
                                                      style={{ color: Colors.white_color, backgroundColor: Colors.Base_color }}
                                                    >Submit</button>
                                                }

                                              </div>
                                            </div>
                                          </form>
                                        </AccordionDetails>
                                      </Accordion>
                                    )
                                  }) : null
                              }
                              {
                                order.order_status == 3 && order.return_details == null && order.return_status == 1 ? <>
                                  <button className="return-btn" onClick={() => ShowCheck(order)}>Return / Exchange ?</button> <br></br><span style={{ color: "#495057", fontSize: "14px" }} className="m-1">Eligible to return the product until {moment(order.updated_at).add(settings.return_days, "days").format('DD-MMM-yyyy')}</span></> : order.order_status == 3 && order.return_details == null && order.return_status == 3 ?
                                  <button className="return-btn" style={{ cursor: "text" }}>Return Expired</button> : null
                              }
                              <hr></hr>
                              <div className="track-order">
                                <Accordion>
                                  <AccordionSummary expandIcon={<img src={arrow} className="rotatearrow" alt="open"></img>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <h4 className="review-title">Track Order</h4>
                                  </AccordionSummary>
                                  <AccordionDetails>

                                    {order.order_status != "cancelled" ? <Stepper activeStep={order.order_status == "pending" ? 1 :order.order_status == "processing" ? 2 :order.order_status == "completed" ? 3 : 3  } orientation="vertical">
                                      {steps.map((step, index) => (
                                        <Step key={step.label}>
                                          <StepLabel>{step.label}</StepLabel>
                                          <StepContent><Typography>{step.description}</Typography></StepContent>
                                        </Step>
                                      ))}
                                    </Stepper> : <h4 className="m-3">Order Cancelled!</h4>}

                                  </AccordionDetails>
                                </Accordion>
                              </div>
                              {
                                order.return_details !== null ?
                                  <div>
                                    <hr></hr>
                                    <div className="track-order">
                                      <Accordion>
                                        <AccordionSummary expandIcon={<img src={arrow} className="rotatearrow" alt="open"></img>}
                                          aria-controls="panel1a-content"
                                          id="panel1a-header">
                                          <h4 className="review-title">Track Return Order</h4>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {
                                            order.return_details.status === 0 ? <h5 className="m-3">Return request rejected!</h5> : <Stepper activeStep={order.return_details.status} orientation="vertical">
                                              {return_steps.map((step, index) => (
                                                <Step key={step.label}>
                                                  <StepLabel>{step.label}</StepLabel>
                                                  <StepContent><Typography>{step.description}</Typography></StepContent>
                                                </Step>
                                              ))}
                                            </Stepper>
                                          }
                                          {
                                            order.return_details.status === 4 ?
                                              <>
                                                <p className="mt-5">{settings != '' ? settings.currency.symbol : ''} {order.return_details.total_refund_amount} refunded through {order.return_details.refund_type === 1 ? "Wallet" : "offline"}</p>
                                              </>
                                              : null
                                          }
                                        </AccordionDetails>
                                      </Accordion>

                                    </div>
                                  </div> : null
                              }
                              <hr></hr>
                              <div className="Order-details">
                                <Accordion>
                                  <AccordionSummary expandIcon={<img src={arrow} className="rotatearrow" alt="open"></img>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header">
                                    <h4 className="review-title">Order Details</h4>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <div className="orders-rates">
                                      <div className="orders-container ">
                                        <div className="left-desc d-flex flex-column gap-2">
                                          <small>Items Total</small>
                                          <small>Tax ({order.tax_percentage}%)</small>
                                          {
                                            order.packing_charges > 0 ?
                                              <small>Packing Charges</small> : null
                                          }
                                          {
                                            order.delivery_charges > 0 ?
                                              <small>Delivery Charges</small> : null
                                          }
                                          {
                                            order.discount_amount > 0 ?
                                              <small>Promo</small> : null
                                          }
                                          <small className="grand">Grand Total</small>
                                        </div>
                                        <div className="left-desc d-flex flex-column gap-2">
                                          <small>:</small>
                                          <small>:</small>
                                          {
                                            order.packing_charges > 0 ?
                                              <small>:</small> : null
                                          }
                                          {
                                            order.delivery_charges > 0 ?
                                              <small>:</small> : null
                                          }
                                          {
                                            order.discount_amount > 0 ?
                                              <small>:</small> : null
                                          }
                                          <small>:</small>
                                        </div>
                                        <div className="amounts d-flex flex-column gap-2">
                                          <small>{settings != '' ? settings.currency.symbol : ''} {calculateValue(order.order_items)}</small>
                                          <small>{settings != '' ? settings.currency.symbol : ''} {order.tax_amount}</small>

                                          {
                                            order.packing_charges > 0 ?
                                              <small>{settings != '' ? settings.currency.symbol : ''} {order.packing_charges}</small> : null
                                          }
                                          {
                                            order.delivery_charges > 0 ?
                                              <small>{settings != '' ? settings.currency.symbol : ''} {order.delivery_charges}</small> : null
                                          }
                                          {
                                            order.discount_amount > 0 ?
                                              <small>-{settings != '' ? settings.currency.symbol : ''} {order.discount_amount}</small> : null
                                          }
                                          <small className="grand-amount">{settings != '' ? settings.currency.symbol : ''} {order.total_amount}</small>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="payment">
                                      <h4 className="review-title" style={{ paddingTop: "20px" }}>Payment Method</h4>
                                      <div className="modeofpay d-flex gap-3">
                                        <span style={{ color: "#126a38" }}>Mode of Payment</span>
                                        <span style={{ color: "#126a38" }}>:</span>
                                        <span className="credit">{order.payment_type} <i class="fa-solid fa-circle-check" style={{ color: "green" }}></i></span>
                                      </div>
                                    </div>
                                    <div className="shipping-address">
                                      <h4 className="review-title" style={{ paddingTop: "20px" }}>Shipping Address</h4>
                                      <span>{order.address_id.address_1}</span> <br></br>
                                      <span>{order.address_id.city} </span><br></br>
                                      <span>{order.address_id.post_code}</span>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                              </div>
                            </Accordion>
                          </li>
                        )
                      }) : <div className="text-center">You have no orders!</div>
                  }
                </ul>

                <Pagination siblingCount={1} boundaryCount={0} count={(totalCount / 4).toString().split(".")[1] == undefined ? parseInt((totalCount / 4).toString().split(".")[0]) : parseInt((totalCount / 4).toString().split(".")[0]) + 1} variant="outlined" style={{ display: orderDetails ? orderDetails.length != 0 ? "block" : "none" : "none" }} shape="rounded" defaultPage={1} onChange={(e, page) => { handleChangePage(page) }} />
              </div> :
              apiTxt == "No order found" ? <div className="d-flex justify-content-center w-100 py-5">You have no orders!</div> : <div
                className="d-flex align-items-center justify-content-center w-100"
                style={{ height: "100vh" }}
              >
                <MutatingDots
                  height="100"
                  width="100"
                  color={Colors.Base_color}
                  secondaryColor={Colors.Base_color}
                  radius="12.5"
                  ariaLabel="mutating-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
              }
            </div>

          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default Myorder;